import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import async from 'async';
import { CommonStyles, CommonTheme } from '../styles/Styles';
import { AppTheme } from '../styles/AppTheme';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Icon from '@material-ui/core/Icon';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ListItemRender } from '../components/ListItemRender';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { Helper } from '../common/helpers/Helper';
import { UiHelper } from '../common/helpers/UiHelper';
import { AppHelper } from '../helpers/AppHelper';

export class Categories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchState: ApiHelper.State.LOADING,
    }
  }

  componentDidMount() {
    this.fetchItems()
  }

  fetchItems() {
    async.parallel(
      [
        function (callback) {
          ApiHelper.call(
            { method: 'GET', authWithKey: true, endPoint: ApiHelper.makeUrlPath(['miscs', 'cats']) },
            callback)
        }
      ],
      function (err, results) {
        if (err) {
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }

        this.setState({
          mainCategories: results[0].items,
        }, () => this.setCategories())
      }.bind(this))
  }

  setCategories() {
    let categories = []

    for (const m of this.state.mainCategories) {
      if (m.parentId === 'ROOT') {
        categories.push({
          id: m.id,
          parentId: m.parentId,
          title: m.title,
          slug: m.slug,
          state: m.state,
          subCategories: []
        })
      }
    }

    categories = AppHelper.sortByName(categories)

    for (const c of categories) {
      for (const m of this.state.mainCategories) {
        if (c.id === m.parentId) {
          c.subCategories.push({
            id: m.id,
            parentId: m.parentId,
            title: m.title,
            slug: m.slug,
            state: m.state,
            subCategories: []
          })
        }
      }
      c.subCategories = AppHelper.sortByName(c.subCategories)
    }

    for (const c of categories) {
      for (const sc of c.subCategories) {
        for (const m of this.state.mainCategories) {
          if (sc.id === m.parentId) {
            sc.subCategories.push({
              id: m.id,
              parentId: m.parentId,
              slug: m.slug,
              state: m.state,
              title: m.title
            })
          }
        }
        sc.subCategories = AppHelper.sortByName(sc.subCategories)
      }
    }

    this.setState({
      categories: categories,
      fetchState: ApiHelper.State.READY
    })
  }

  render() {
    return this.readyView();
  }

  readyView() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return (
        <div className={css(Styles.subContainer)}>
          <div className={css(Styles.progressBar)}>
            <CircularProgress size={35} className={css(CommonStyles.progress)} />
          </div>
        </div>
      )
    }
    return (
      <div className={css(Styles.subContainer)}>
        {this.state.categories &&
          <ListItemRender
            title={'SPECIALTIES'}
            data={this.state.categories}
            openId={this.props.openId}
            openSubId={this.props.openSubId}
            nsItem={this.props.nsItem}
            slug={this.props.slug}
          />
        }
      </div>
    )
  }
}

const BORDER_RADIUS = 15
const WIDTH = '80%'
export const Styles = StyleSheet.create({
  subContainer: {
    backgroundColor: CommonTheme.white,
    borderRadius: BORDER_RADIUS,
    width: WIDTH,  //TODO
    margin: '30px 0px 0px 0px',
    overflow: 'hidden',
    boxShadow: '2px 2px 15px  rgba(19, 19, 19, 0.2)',//TODO Need?
    '@media (max-width: 767px)': {
      width: CommonTheme.mobViewPort,
      margin: '15px 0px 0px 0px',
    },
  },
  progressBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: AppTheme.pagePadding * 2,
    minHeight: '370px',
    '@media (max-width: 767px)': {
      minHeight: 0,
    }
  },
})


// WEBPACK FOOTER //
// ./src/components/Categories.js